import { getAccountRegion } from '../../../../utils/region';

export function getBannerLabel(session) {
  const countryCode = getAccountRegion(session);

  if (countryCode === 'GB') {
    return 'SOLD STC';
  }

  return 'JUST SOLD';
}

// Resolves the banner label for a multi-listing ad. For the let variant the
// label is driven by the user-edited banner_text, toggle off means no banner.
// For the sold variant we keep the legacy country-derived fallback.
// See REACH-2436.
export function resolveBannerLabel(adContentSet) {
  const campaignType =
    adContentSet?.campaign_type ?? adContentSet?.type ?? null;

  if (campaignType === 'multi_listing_let') {
    const explicitBanner =
      adContentSet?.prospecting?.banner_text?.label ??
      adContentSet?.banner ??
      null;
    return explicitBanner ? explicitBanner.toUpperCase() : null;
  }

  return getBannerLabel(adContentSet?.session);
}
